import React, {useState} from 'react';
import styles from './description.module.scss';
import {numberFormat} from "@/app/number";
import {PURCHASE} from "@/actions/types";
import {useDispatch} from "react-redux";
import { nl2p } from '@/app/general';

type Props = {
  post: IPostDetails | null
};

const PostDescription: React.FC<Props> = ({ post }) => {
    // todo download buttons for purchased posts
    const dispatch = useDispatch();

    const buyPost = () => {
        dispatch({
            type: PURCHASE,
            payload: { postId: post?.id }
        });
    }

    const real_price = Number(post?.real_price || 0);
    const price = Number(post?.price || 0);

  return (
    <div className={styles.postDescription}>
        {!post?.bought ? (
            <div className={styles.header}>
                <div className={styles.price}>
                    <span>قیمت کل</span>
                    <span>{post && price === 0 ? 'رایگان' : (real_price > price ? (
                        <>
                        <span className={styles.hasOff}>
                            <span className={styles.realPrice}>{numberFormat(real_price)}</span>
                            <span className={styles.offPrice}>{numberFormat(price)}</span>
                        </span>
                        <span> تومان </span>
                        </>
                    ) : numberFormat(price) + ' تومان')}</span>
                </div>
                {post && price === 0 ? null : (
                    <div className={styles.addToCart}>
                        <button type="button" className="btn btn-primary" onClick={buyPost}>
                            <i className="fa fa-shopping-basket" /> { ' ' }
                            <span>خرید فایل ها</span>
                        </button>
                    </div>
                )}
            </div>
        ) : ''}
      <div className={styles.description}>
          <h3>{post?.title || 'در حال بارگزاری...'}</h3>
          <div className={styles.summary}>{nl2p(post?.summary || '')}</div>
          <div className={styles.content}>{nl2p(post?.description || '')}</div>
      </div>
    </div>
  );
}

export default PostDescription;
